import { render, staticRenderFns } from "./integralRuleList.vue?vue&type=template&id=14974ffe&scoped=true"
import script from "./integralRuleList.vue?vue&type=script&lang=js"
export * from "./integralRuleList.vue?vue&type=script&lang=js"
import style0 from "./integralRuleList.vue?vue&type=style&index=0&id=14974ffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14974ffe",
  null
  
)

export default component.exports